import React from "react";

const Swarmed = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <iframe
        src="/swarmed/index.html"
        width="1920"
        height="1080"
        style={{ border: "none" }}
        title="Game"
      />
    </div>
  );
};
  
export default Swarmed;